import { tns } from 'tiny-slider/src/tiny-slider';

class TestimonialsSlider {
	constructor(el, prevButton, nextButton) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		const testimonialsSlider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: false,
			autoplayButtonOutput: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton
		});

		const prevControl = this.prevButton.closest('button');
		const nextControl = this.nextButton.closest('button');

		if (prevControl) {
			prevControl.addEventListener('click', (e) => {
				if (e.target === prevControl) {
					this.prevButton.click();
				}
			});
		}

		if (nextControl) {
			nextControl.addEventListener('click', (e) => {
				if (e.target === nextControl) {
					this.nextButton.click();
				}
			});
		}

		return testimonialsSlider;
		
	}
}

export default TestimonialsSlider;